/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Vehicle_HistoryInputs */

const fr_map_vehicle_history = /** @type {(inputs: Map_Vehicle_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir l'historique`)
};

const en_map_vehicle_history = /** @type {(inputs: Map_Vehicle_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View history`)
};

/**
* | output |
* | --- |
* | "View history" |
*
* @param {Map_Vehicle_HistoryInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_vehicle_history = /** @type {((inputs?: Map_Vehicle_HistoryInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Vehicle_HistoryInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_vehicle_history(inputs)
	return en_map_vehicle_history(inputs)
});